import { withLocalization, LocalizedComponentClass, LocalizedComponentProps } from 'bernie-l10n';
import * as React from 'react';
import { UitkDealGenericBadge } from 'uitk-react-badge';
import { UitkIcon } from 'uitk-react-icons';
import { ActivityBadgeType, ActivityDetailOffersWithAvailability } from '../../../../common/__generated__/api';
import { getBadge } from './image-badges';
import Badges = ActivityDetailOffersWithAvailability.Badges;

export interface ActivityDiscountBadgeProps extends LocalizedComponentProps {
  badges: Badges;
  discountPercent: number;
}

export const ActivityDiscountBadge = withLocalization(
  ({ badges, discountPercent, l10n }: ActivityDiscountBadgeProps) => {
    if (discountPercent <= 0) {
      return null;
    }

    const renderBadge = (): JSX.Element | null => {
      const primary = badges && badges.primary;
      const secondary = badges && badges.secondary;
      const isCampaignDeal = secondary && secondary.type === ActivityBadgeType.CAMPAIGN_DEAL;

      if (isCampaignDeal) {
        return (
          <>
            <UitkDealGenericBadge
              text={
                secondary?.text
                  ? secondary.text
                  : l10n.formatText('lx.search.activity.discount', discountPercent.toFixed(0))
              }
            >
              {secondary?.icon && <UitkIcon name={secondary.icon.id} />}
            </UitkDealGenericBadge>
          </>
        );
      }

      return (
        <>
          {primary && primary.text && getBadge(primary.text, primary.icon, primary.mark, primary.type)}
          {secondary && getBadge(secondary.text, secondary.icon, secondary.mark, secondary.type)}
        </>
      );
    };

    return renderBadge();
  }
) as LocalizedComponentClass<ActivityDiscountBadgeProps>;
